/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkflowTriggerEventDto } from '../../models/workflow-trigger-event-dto';
import { WorkflowTriggerEventUpdateDto } from '../../models/workflow-trigger-event-update-dto';

export interface AutomatedProcessUpdateTriggerEvent$Params {
  id: number;
      body: WorkflowTriggerEventUpdateDto
}

export function automatedProcessUpdateTriggerEvent(http: HttpClient, rootUrl: string, params: AutomatedProcessUpdateTriggerEvent$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkflowTriggerEventDto>> {
  const rb = new RequestBuilder(rootUrl, automatedProcessUpdateTriggerEvent.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkflowTriggerEventDto>;
    })
  );
}

automatedProcessUpdateTriggerEvent.PATH = '/automated-process/workflow-trigger/trigger-event/{id}';